import React from 'react'
import styled from 'styled-components'
import Comment from '../../iconsV2/Comment'
import Delivery from '../../iconsV2/Delivery'
import Disposal from '../../iconsV2/Disposal'
import StockCount from '../../iconsV2/StockCount'
import Administration from '../../iconsV2/Administration'
import { Text } from '@lmc/ui-kit/src/general'
import { MedicationStockReason } from '../../types'

interface ActionCellProps {
  type: MedicationStockReason
  title: string
  subtitle?: string
  hasDiscrepancy?: boolean
  onClick?: () => void
}

const renderActionIcon = (type: MedicationStockReason) => {
  switch (type) {
    case MedicationStockReason.STOCK_COUNT:
      return <StockCount />
    case MedicationStockReason.WASTE:
      return <Disposal />
    case MedicationStockReason.RESTOCK:
      return <Delivery />
    case MedicationStockReason.MED_ADMIN:
      return <Administration />
    case MedicationStockReason.NOT_ADMINISTERED:
      return <Comment />
    default:
      return <StockCount />
  }
}

const ActionCell: React.FC<ActionCellProps> = ({
  type,
  title,
  subtitle,
  hasDiscrepancy = false,
  onClick
}) => {
  const isClickable =
    type === MedicationStockReason.MED_ADMIN ||
    type === MedicationStockReason.NOT_ADMINISTERED

  return (
    <ActionCellContainer
      onClick={isClickable ? onClick : undefined}
      $isClickable={true}
    >
      <IconContainer>{renderActionIcon(type)}</IconContainer>
      <TextContainer>
        <Title>{title}</Title>
        {subtitle && <Subtitle level={2}>{subtitle}</Subtitle>}
      </TextContainer>
    </ActionCellContainer>
  )
}

const ActionCellContainer = styled.div<{ $isClickable: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

const Title = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  line-height: 1;
`

const Subtitle = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

export default ActionCell
